import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Don't logout for auth-related endpoints - they handle their own errors
      // Auth endpoints like /auth/complete-invitation, /auth/signin, etc.
      // should be able to return 401 errors without triggering logout
      const isAuthEndpoint = req.url.includes('/auth/');
      
      if (error.status === 401 && !isAuthEndpoint) {
        // Token expired or invalid, logout user
        // Only for non-auth endpoints (protected API calls)
        authService.logout();
        // Could redirect to login page here if needed
      }

      return throwError(() => error);
    })
  );
}; 